export default __webpack_public_path__ + "static/media/pin02.95fddd3b.svg";